import { put, takeLatest } from "redux-saga/effects";

import {
  fetchInvoiceItemMasterListRequest,
  fetchInvoiceItemMasterListSuccess,
  fetchInvoiceItemMasterListFailure,
  InvoiceItemMasterCreateRequest,
  InvoiceItemMasterCreateSuccess,
  InvoiceItemMasterCreateFailure,
  InvoiceItemMasterUpdateRequest,
  InvoiceItemMasterUpdateSuccess,
  InvoiceItemMasterUpdateFailure,
} from "redux/reducers/acclgl/invoiceItemMaster";

import {
  requestInvoiceItemMasterList,
  requestInvoiceItemMasterCreate,
  requestInvoiceItemMasterUpdate,
} from "services/acclgl/invoice-Item-Master";
export function* watchInvoiceItemMaster() {
  yield takeLatest(
    fetchInvoiceItemMasterListRequest,
    fetchInvoiceItemMasterlist
  );
  yield takeLatest(InvoiceItemMasterCreateRequest, InvoiceItemMasterCreate);
  yield takeLatest(InvoiceItemMasterUpdateRequest, InvoiceItemMasterUpdate);
}

function* fetchInvoiceItemMasterlist({ payload }) {
  try {
    const response = yield requestInvoiceItemMasterList(payload);
    yield put(fetchInvoiceItemMasterListSuccess(response));
  } catch (error) {
    yield put(fetchInvoiceItemMasterListFailure("Failed to get list"));
  }
}

function* InvoiceItemMasterCreate({ payload }) {
  try {
    const response = yield requestInvoiceItemMasterCreate(payload);
    yield put(InvoiceItemMasterCreateSuccess(response.data));
  } catch (error) {
    yield put(InvoiceItemMasterCreateFailure("Failed to get list"));
  }
}

function* InvoiceItemMasterUpdate({ payload }) {
  try {
    const response = yield requestInvoiceItemMasterUpdate(payload);
    yield put(InvoiceItemMasterUpdateSuccess(response.data));
  } catch (error) {
    yield put(InvoiceItemMasterUpdateFailure("Failed to get list"));
  }
}
